import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OpnProjectDeadlineListDetailsModel, OpnProjectDeadlineListSaveModel } from '.';

const localApiUrl = `${environment.apiUrl}/RequestOpnProjectDeadlineList`;

@Injectable()
export class OpnProjectDeadlinesListService {

  constructor(private http: HttpClient) { }

  delete(id: number): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Delete`,id).toPromise();
  }

  save(model: OpnProjectDeadlineListSaveModel): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }

  getById(id: number): Promise<OpnProjectDeadlineListDetailsModel> {
    return this.http.get<OpnProjectDeadlineListDetailsModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

}
